<mat-list-item class="p-0" [attr.id]="buildControlId('list-item-container')">
  <mat-form-field floatLabel="{{ floatLabel }}" class="w-100">
    <mat-label
      >{{ floatLabel }}
      @if (requiredLabel) {
        <span class="labelRequired">*</span>
        }</mat-label
        >
        <mat-select
          #selector
          [attr.id]="buildControlId('ddl-root')"
          [formControl]="selectFormControl"
          class="{{ mode }}"
          placeholder="{{ placeHolder | translate }}"
          [compareWith]="equals"
          (openedChange)="close($event)"
          multiple
          disableOptionCentering
          (selectionChange)="handleSelectAll(); emitSelectionChanged()"
          panelClass="ml-30  multiSelectPanelContainer {{ custompanelClass }}"
          >
          <mat-select-trigger>
            <span
              class="multiselect_tag"
              matTooltipClass="tooltip-style"
              matTooltipPosition="above"
          matTooltip="{{
            selectFormControl?.value[0]?.id === -1
              ? selectFormControl.value[1]?.displayText
              : (selectFormControl?.value[0]
              ? selectFormControl.value[0]?.displayText
              : '')
          }}"
              [attr.id]="buildControlId('lbl-primary-selection')"
              >
              {{
              selectFormControl?.value[0]?.id === -1
              ? selectFormControl.value[1]?.displayText
              : (selectFormControl?.value[0]
              ? selectFormControl.value[0]?.displayText
              : "")
              }}
            </span>
            @if (
              selectFormControl.value?.length > 1 && !showClearBox && showSearch
              ) {
              <span
                class="example-additional-selection"
                (click)="overlaydisplay(selectFormControl.value, $event)"
                [attr.id]="buildControlId('btn-expand-selection', 'search')"
                >
                +{{ selectFormControl?.value[0]?.id === -1
                ? selectFormControl.value.length - 2
                : (selectFormControl?.value[0]
                ? selectFormControl.value.length - 1
                : 0)}} more
              </span>
            }
            @if (
              selectFormControl.value?.length > 1 && (showClearBox || !showSearch)
              ) {
              <span
                class="example-additional-selection"
                (click)="overlaydisplay(selectFormControl.value, $event)"
                [attr.id]="buildControlId('btn-expand-selection', 'default')"
                >
                +{{ selectFormControl.value.length - 1 }} more
              </span>
            }
          </mat-select-trigger>
          <div [hidden]="!showSearch">
            <mat-form-field class="search-field width" floatLabel="never">
              <input matInput #search name="search-text" autocomplete="off" (keydown)="$event.stopPropagation()"
                placeholder="{{ 'Common.Search.Placeholder' | translate }}" [formControl]="searchTextboxControl"
                [attr.id]="buildControlId('fld-search')" />
                @if (!search.value) {
                  <span class="icon-ic-Search-link" matSuffix></span>
                }
                @if (search.value) {
                  <button matSuffix mat-icon-button (click)="clearSearch()"
                    [attr.id]="buildControlId('btn-clear-search')">
                    <span class="icon-ic-remove-doc color-error"></span>
                  </button>
                }
              </mat-form-field>
              <div class="search-field p-t-s p-l-l" [hidden]="displayItemsForSearch.length!==0" i18n="@@Common.MultiSelect.NoResults">No
          results found!</div>
            </div>
            <div id="mat-multiselect" class="max-height-22">

              <div class="multiSelectDropdownOptions">
                @if (selectAllRequired && showSelectAll) {
                  <mat-checkbox [ngClass]="{ 'ActionItemcolor': selectedItems.length===0 || selectAllChecked }"
                    class="w-100 custom-checkbox" [checked]="selectAllChecked" [indeterminate]="selectAllindeterminate" (change)="setSelectAll($event.checked)"
                    [attr.id]="buildControlId('chk-select-all')">
                    {{selectAllLabel}}
                  </mat-checkbox>
                }
                @for (item of filteredOptions(); track item; let index = $index) {
                  <mat-option [class.multiSelectDropdownOptions.mat-option.mat-active]="selectAllRequired  && !firstOptionChecked"
                    [ngClass]="{ 'ActionItemcolor': (selectedItems.length===0 && index === 0) && !selectAllRequired }"
                    [disabled]="disableSelection"
                    [value]="item"
                    class="multi-select-option"
                    (onSelectionChange)="selectionChange($event)"
                    >
                    {{ item.displayText }}
                  </mat-option>
                }
              </div>

            </div>
            <div class="multiSelectClearButton" [hidden]="filteredOptions().length === 0">
              <button
                mat-button
                color="accent"
                [disabled]="disableClear"
                class="w-100"
                (click)="clearSearchWithData()"
                [attr.id]="buildControlId('btn-clear-selection')"
                >
                Clear
              </button>
            </div>
          </mat-select>
        </mat-form-field>
      </mat-list-item>
